import { useState, useLayoutEffect } from 'react'
import jwtDecode from 'jwt-decode'
import { useSelector } from 'react-redux'
import { RootState } from 'dataStore/state'
import { useActions } from 'hooks/useActions'
import { IUser } from 'dto/users.dto'
import { isPanelManager } from 'handlers/isPanelManager'

interface AdminTokenPayload {
  id?: number
  is_admin?: boolean | null
}

/**
 * Текущий админ из JWT + списка users (для parentId / прав субадмина и менеджера).
 */
export const useRole = () => {
  const { getAllUsers } = useActions()
  const { users } = useSelector((state: RootState) => state.users)

  const [decodedOldToken, setDecodedOldToken] = useState<AdminTokenPayload>()
  const [user, setUser] = useState<IUser | null>(null)

  const token = localStorage.getItem('token')
  if (token && !decodedOldToken) {
    try {
      setDecodedOldToken(jwtDecode<AdminTokenPayload>(token))
    } catch {
      setDecodedOldToken(undefined)
    }
  }

  useLayoutEffect(() => {
    if (!users || users.length === 0) getAllUsers()
    if (users.length > 0 && decodedOldToken && !user) {
      const currentUser = users?.find(
        userItem => userItem?.id === decodedOldToken?.id
      )
      if (currentUser) {
        setUser(currentUser)
      }
    }
  }, [users, decodedOldToken])

  const parentId = user?.parentId
  /** Субадмин = есть parentId (не суперадмин) */
  const isSubAdmin = typeof parentId === 'number' && parentId > 0
  const isManager = user
    ? isPanelManager(user)
    : isPanelManager(decodedOldToken)

  return {
    parentId,
    userId: user?.id ?? decodedOldToken?.id,
    user,
    isSubAdmin,
    isManager,
    isRoleReady: Boolean(user?.id) || typeof decodedOldToken?.id === 'number',
  }
}
